export default [
	'Luxo',
	'Alto',
	'Médio',
	'Popular',
	'n/a',
];
